<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
};
</script>

<style>
.v-navigation-drawer__content {
  overflow-y: hidden;
}
#app .v-application .caption,
#app .v-application .text-caption,
#app .v-application .text-subtitle-1,
#app .v-application .subtitle-2,
#app .v-application .body-1,
#app .v-application .body-2,
#app .v-application .headline,
#app .v-application .title {
  font-family: 'Lato', sans-serif !important;
}

.v-application .v-select__slot {
  position: unset;
}

.v-application .v-select__selections {
  margin-top: 8px;
}

.v-application .v-select__slot .v-label {
  margin-left: 12px;
}
</style>
